import React from "react";
import "./App.css";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <div className="logo-container">
          <img
            src="/logo-sgi.png"
            alt="SGI Informática"
            className="company-logo"
          />
        </div>
        <h1>Radar SGI Informática</h1>
        <p className="subtitle">Em breve estaremos ativos</p>
        <div className="url-display">
          <span className="url-text">radar.sgiinformatica.com.br</span>
        </div>
        <div className="coming-soon">
          <p>Sistema em desenvolvimento</p>
          <div className="loading-dots">
            <span>.</span>
            <span>.</span>
            <span>.</span>
          </div>
        </div>
      </header>
    </div>
  );
}

export default App;
